





































import { Component, Prop, Vue } from 'vue-property-decorator'
import { LoginProfile } from '../types'

@Component
export default class ForgotScreen2 extends Vue {
  @Prop({ type: Object, required: true }) readonly loginAs!: LoginProfile

  loading: boolean = false

  sendSms () {
    this.sendMessage('tel')
  }

  sendEmail () {
    this.sendMessage('email')
  }

  sendMessage (method: string) {
    this.loading = true
    this.$axios.post('/forgot/send-recovery-message', { username: this.loginAs.username, method }, {
      headers: {
        'CSRF-Token': this.$q.cookies.get('xsrf')
      },
      withCredentials: true
    }).then(async ({ data }) => {
      if (data.ok) {
        this.$q.notify({
          message: (method === 'tel'
            ? this.$t(this.$msg.SentSms)
            : this.$t(this.$msg.SentEmail)).toString(),
          color: 'positive',
          position: 'top'
        })
        this.$emit('sent', method)
      } else if(data.errors) {
        const errors = Object.values(data.errors).shift() as string[]
        this.$q.notify({
          message: errors[0],
          color: 'negative',
          position: 'top'
        })
      }
    }).finally(() => {
      this.loading = false
    })
  }
}
